import React from 'react';
import { connect } from 'react-redux';
import { useKeycloak } from '@react-keycloak/web';
import Loading from './loading/Loading';

function StartupLoader({ user, children }) {
    const { keycloak, initialized } = useKeycloak();

    if (!initialized || !keycloak.authenticated || user.isLoading) {
        return <Loading />;
    }

    return children;
}

export default connect(state => ({
    user: state.user,
}))(StartupLoader);
